import React from "react";
import { useState } from "react";

import "./CourseBuilder.scss";
import logo from "../../../../../assets/icons/logo.png";

const defaultState = [
  {
    title: "Experience",
    sections: [
      { header: "teacherExperience", current: 0, icon: "icon icon-courses" },
      { header: "experienceWithVideo", current: 1, icon: "icon icon-courses" },
      { header: "courseReadiness", current: 2, icon: "icon icon-courses" },
      { header: "Let Start", current: 3, icon: "icon icon-courses" },
     
    ],
  },
  {
    title: "CourseTypes",
    sections: [
      { header: "CourseTypes", current: 4, icon: "icon icon-courses" },
      { header: "courseName", current: 5, icon: "icon icon-courses" },
      { header: "category", current: 6, icon: "icon icon-courses" },
      { header: "Start Process", current: 7, icon: "icon icon-courses" },
     
    ],
  },
  {
    title: "Outline your course",
    sections: [
      { header: "Define Goals", current: 8, icon: "icon icon-courses" },
      { header: "Course One Liner", current: 9, icon: "icon icon-courses" },
      {
        // header: "Course Out Description",
        header: "Course skilled cover",
        current: 10,
        icon: "icon icon-courses",
      },
      { header: "Pre-requisites", current: 11, icon: "icon icon-courses" },
      { header: "Course Description", current: 12, icon: "icon icon-courses" },
      { header: "Course FAQs", current: 13, icon: "icon icon-courses" },
      { header: "Course Syllabus", current: 14, icon: "icon icon-courses" },
      { header: "Course Level", current: 15, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Create your media",
    sections: [
      { header: "Course Image", current: 16, icon: "icon icon-courses" },
      { header: "Course Video", current: 17, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Publish Course",
    sections: [
      {
        header: "Course details page",
        current: 18,
        icon: "icon icon-courses",
      },
      { header: "Price Your Course", current: 19, icon: "icon icon-courses" },
    ],
  },
];

const createBundle = [
  {
    title: "Outline Your Bundle",
    sections: [
      { header: "Define Goals", current: 8, icon: "icon icon-courses" },
      { header: "Bundle One Liner", current: 9, icon: "icon icon-courses" },
      { header: "Pre-requisites", current: 10, icon: "icon icon-courses" },
      { header: "Bundle Description", current: 11, icon: "icon icon-courses" },
      { header: "Bundle FAQs", current: 12, icon: "icon icon-courses" },
      { header: "Bundle Level ", current: 13, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Add media",
    sections: [
      { header: "Bundle Image", current: 14, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Publish Your Bundle",
    sections: [
      {
        header: "Bundle details",
        current: 15,
        icon: "icon icon-courses",
      },
      { header: "Price your Bundle", current: 16, icon: "icon icon-courses" },
    ],
  },
];

const webinarDefaultState = [
  {
    title: "Outline your course",
    sections: [
      { header: "Course Description", current: 9, icon: "icon icon-courses" },
      { header: "Course Level", current: 10, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Create your media",
    sections: [
      { header: "Course Image", current: 11, icon: "icon icon-courses" },
    ],
  },
  {
    title: "Publish Course",
    sections: [
      { header: "Price Your Course", current: 12, icon: "icon icon-courses" },
      {
        header: "Webinar Scheduler",
        current: 13,
        icon: "icon icon-courses",
      },
    ],
  },
];

const CourseBuilderSidebar = ({
  current,
  isValid,
  setActiveSlide,
  formValues,
  coursebuilderToggle,
  setcoursebuilderToggle,
  storedSession,
  location,
}) => {
  const [sideBarSections] = useState(
    location === "createBundle"
      ? createBundle
      : storedSession === "liveCourse"
      ? webinarDefaultState
      : defaultState
  );
  const setStyle = (currentSection) => {
    return currentSection === current
      ? "active"
      : isValid(currentSection)
      ? "valid"
      : "";
  };

  const handleClick = (event, currentSelection) => {
    event.preventDefault();
    if (isValid(currentSelection)) {
      setActiveSlide(currentSelection);
    }
  };
  return (
    <>
      <div
        className={
          coursebuilderToggle
            ? "CourseBuilderSidebar-left"
            : "CourseBuilderSidebar-left-1"
        }
      >
        <div className="courseBuilder-logo">
          {coursebuilderToggle && (
            <img
              // src={`${process.env.REACT_APP_LOGIN_API_BASEURL}/UI/smiklearn-course-builder-logo.svg`}
              src={logo}
              alt="Course Builder"
            />
          )}

          <div
            className="abc"
            onClick={() => {
              setcoursebuilderToggle(!coursebuilderToggle);
            }}
          >
            <i className="icon icon-burger"></i>
          </div>
        </div>
        <div className="CourseBuilderSidebar-left-menu">
          {sideBarSections.map((section, index) => (
            <ul key={index}>
              <div>{coursebuilderToggle && section.title}</div>
              {section.sections.map((item, index) => (
                <li key={index + item.current}>
                  <a
                    href="javascript(void);"
                    className={setStyle(item.current)}
                    onClick={(event) => handleClick(event, item.current)}
                  >
                    {coursebuilderToggle ? (
                      item.header
                    ) : (
                      <i className={item.icon}></i>
                    )}
                  </a>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </>
  );
};
export default CourseBuilderSidebar;
